import { alpha, styled } from '@mui/material/styles';
import { DataGridPro } from '@mui/x-data-grid-pro';
import is from '@sindresorhus/is';

import { Shade } from '../theming';

export const StyledDataGrid = styled(DataGridPro)(({ onRowClick, theme }) => ({
    ['& .MuiDataGrid-columnHeaders']: {
        backgroundColor: theme.palette.grey['50'],
        borderBottom: 'none',
        color: alpha(theme.palette.text.secondary, Shade.p60),
        fontSize: theme.typography.body2.fontSize,
        textTransform: 'uppercase',
    },
    ['& .MuiDataGrid-footerContainer']: {
        ['.MuiTablePagination-select']: { fontSize: theme.typography.body2.fontSize },
        ['.MuiTablePagination-selectLabel']: { color: alpha(theme.palette.text.secondary, Shade.p60) },
    },
    ['& .MuiDataGrid-row']: {
        cursor: `${is.function(onRowClick) === true ? 'pointer' : 'default'}`,
    },
    ['& .MuiDataGrid-row:hover']: { backgroundColor: alpha(theme.palette.secondary.main, Shade.p8) },
    ['.MuiDataGrid-booleanCell']: {
        alignSelf: 'center',
    },
    ['.MuiDataGrid-cell, .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox)']: {
        paddingInline: theme.spacing(2),
    },
    ['.MuiGrid-root, .MuiDataGrid-cellContent']: {
        alignItems: 'center',
        display: 'flex',
        height: 'auto',
        minHeight: '53px',
        overflow: 'hidden',
    },
    border: 'none',
    fontSize: theme.typography.body1.fontSize,
    height: '100%',
    width: '100%',
}));
